module.exports = __webpack_public_path__ + "img/energySaving-icon_1.b08c4fc0.png";